

module.exports = __webpack_require__.stylable.create(
    "Image2156886798",
    {"classes":{"root":"Image2156886798__root"},"vars":{},"stVars":{},"keyframes":{}},
    ".Image2156886798__root{display:inline-block;overflow:hidden;border-radius:6px;font-size:0;background-color:#dfe5eb;max-width:100%;max-height:100%;text-indent:100vw}.Image2156886798__root.Image2156886798--tiled{background-repeat:repeat;object-position:-100vw;object-fit:none}",
    2,
    "Image2156886798",
    __webpack_require__.stylable.$
);
